import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "apollo-link-context";
import { CLIENT_CONFIG, loginRequest } from "./config";

import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";

const apiEndpoint: string | undefined = process.env.REACT_APP_API_ENDPOINT;

const link = createUploadLink({ uri: CLIENT_CONFIG.api });

export const createClient = (
  instance: IPublicClientApplication,
  account: AccountInfo
) => {
  // Inject access token into the GraphQL request, this is run on each API
  // request, if there is a valid token in the cache it's used and the request
  // proceeds otherwise either use a refresh token to acquire a new access
  // token or make the user reauthenticate.
  const authLink = setContext(async (_, { headers }) => {
    const result = await instance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });

    return {
      headers: {
        ...headers,
        Authorization: result.accessToken ? `Bearer ${result.accessToken}` : "",
      },
    };
  });
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(link),
  });
};
